import { render } from "./StarTipDialog.vue?vue&type=template&id=42c8efdc&scoped=true&ts=true"
import script from "./StarTipDialog.vue?vue&type=script&lang=ts"
export * from "./StarTipDialog.vue?vue&type=script&lang=ts"

import "./StarTipDialog.vue?vue&type=style&index=0&id=42c8efdc&scoped=true&lang=css"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c8efdc"]])

export default __exports__